import ItemRow from './ItemRow.container'

export default ItemRow
